if (!customElements.get('union-shirt-gallery')) {
  customElements.define('union-shirt-gallery', class extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const button = event.target.closest('[data-shirt-view]');
        if (!button || !this.contains(button)) return;
        const panel = button.closest('[data-shirt-color]');
        const main = panel.querySelector('[data-shirt-main]');
        main.src = button.querySelector('img').src;
        main.alt = `Union shirt - ${panel.dataset.shirtColor} - ${button.dataset.shirtView}`;
        panel.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      this.onChange = event => {
        const color = String(event.target.value || '').toLowerCase().trim().replace(/\s+/g, '-');
        if (!color || !this.querySelector(`[data-shirt-color="${color}"]`)) return;
        this.querySelectorAll('[data-shirt-color]').forEach(panel => { panel.hidden = panel.dataset.shirtColor !== color; });
        this.dataset.color = color;
      };
      this.scope = this.closest('[data-section-type="product-page"]') || this.parentElement;
      this.addEventListener('click', this.onClick);
      this.scope.addEventListener('change', this.onChange);
      this.onSwatch = event => { const swatch = event.target.closest('.product-option-item[data-value]'); if (swatch) this.onChange({target: {value: swatch.dataset.value}}); };
      this.scope.addEventListener('click', this.onSwatch);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('click', this.onSwatch);
    }
  });
}
